module.exports = __webpack_public_path__ + "static/img/6.c1a7ba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/6.png
// module id = /sLU
// module chunks = 0